import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../utils/auth";
import { processFollowUpPhones } from "../../api/OrderAPIs";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Phone, Send, ArrowRight } from "lucide-react";

const FollowUpPhonesPage = () => {
  const navigate = useNavigate();
  const { authState } = useAuth();
  const [phoneNumbers, setPhoneNumbers] = useState("");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phoneNumbers.trim()) {
      toast.error("أدخل رقم واحد على الأقل");
      return;
    }

    setLoading(true);
    setResults(null);
    try {
      const data = await processFollowUpPhones(phoneNumbers);
      setResults(data);
      toast.success(`تم معالجة ${data.processed} من ${data.total} رقم`);
    } catch (err) {
      toast.error(err.message || "فشل المعالجة");
    } finally {
      setLoading(false);
    }
  };

  if (authState.role !== "Admin" && authState.role !== "Moderator") {
    return (
      <div className="min-h-screen flex items-center justify-center text-white bg-gray-900">
        غير مصرح
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 text-white p-6" dir="rtl">
      <ToastContainer position="top-center" theme="dark" />
      <div className="max-w-3xl mx-auto">
        <button
          onClick={() => navigate("/dashboard")}
          className="mb-6 flex items-center gap-2 text-purple-200 hover:text-white"
        >
          <ArrowRight size={18} />
          العودة للوحة التحكم
        </button>

        <div className="bg-white/10 backdrop-blur-md rounded-2xl border border-white/20 p-6 shadow-xl">
          <div className="flex items-center gap-3 mb-4">
            <Phone className="text-purple-300" />
            <h1 className="text-2xl font-bold">متابعة تأكيد الطلبات (WhatsApp)</h1>
          </div>

          <p className="text-purple-100 mb-4 text-sm leading-relaxed">
            أدخل أرقام العملاء (رقم في كل سطر). سيتم تحديث <strong>آخر طلب فقط</strong> لكل رقم إلى
            <strong> Waiting Confirming </strong>
            وإرسال قالب المتابعة (82964) عبر BeOn.
          </p>

          <form onSubmit={handleSubmit}>
            <textarea
              value={phoneNumbers}
              onChange={(e) => setPhoneNumbers(e.target.value)}
              rows={10}
              placeholder={"01002154996\n01555069856\n01234567890"}
              className="w-full rounded-xl bg-black/30 border border-white/20 p-4 text-white placeholder-purple-200/50 focus:outline-none focus:ring-2 focus:ring-purple-400 font-mono text-left"
              dir="ltr"
            />

            <button
              type="submit"
              disabled={loading}
              className="mt-4 w-full flex items-center justify-center gap-2 bg-purple-600 hover:bg-purple-500 disabled:opacity-50 rounded-xl py-3 font-semibold transition"
            >
              <Send size={18} />
              {loading ? "جاري الإرسال..." : "إرسال متابعة التأكيد"}
            </button>
          </form>

          {results && (
            <div className="mt-6 bg-black/20 rounded-xl p-4 border border-white/10">
              <p className="mb-3 font-semibold">
                النتائج: {results.processed} ناجح من {results.total}
              </p>
              <ul className="space-y-2 text-sm">
                {results.results?.map((r, i) => (
                  <li key={i} className={`p-2 rounded ${r.success ? "bg-green-900/30" : "bg-red-900/30"}`}>
                    <span className="font-mono">{r.phone}</span>
                    {r.orderId && <span> — طلب #{r.orderId}</span>}
                    {r.error && <span className="text-red-300"> — {r.error}</span>}
                    {r.success && <span className="text-green-300"> — تم الإرسال</span>}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FollowUpPhonesPage;
